import styled from 'styled-components';

export const TemperatureAndWeatherStyled = styled.div`
  .temperatureAndWeather {

    &__radioButtonsGroup {
      width: 32%;
    }
    
    &__container {
      background: var(--color-sonata-primary-100, #F2F5FC);
      border-radius: 8px;
      padding: var(--spacing-16);
      margin-top: var(--spacing-16);
      display: flex;
      flex-direction: column;
      gap: var(--spacing-16);
    }

    &__selectors {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &Container {
        width: 50%;
        gap: var(--spacing-16);
        display: flex;
        flex-direction: row;

        & .customInputContainer {
          flex: 1;
        }
      }
    }

    &__selectorDegreeType {
      flex: 1;
    }
    
    &__subtitle {
      font: var(--font-body-400-medium);
      color: var(--color-sonata-primary-700, #283D60);
    }
    
    &__contentTags {
      display: flex;
      width: 100%;
      gap: var(--spacing-8);
      justify-content: space-between;
      align-items: center;
    }
    
    &__risk {
      display: flex;
      width: 100%;
      justify-content: space-between;
      flex-wrap: wrap;

      &Options {
        display: flex;
        gap: var(--spacing-16);
        &Item {
          display: inline-flex;
          align-items: center;
        }
      }
    }

    &__checks {
      display: flex;
      align-items: center;
      gap: var(--spacing-10);
    }
  }
`;
